import React, { useContext } from "react";
import { MouseEvent } from "react";
import { Icon } from "../../Common/Icons/LucideIcons";
import {
  LegendControl,
  LegendControlContainer,
} from "../__styles__/FullPageMap";
import { MapToolContext } from "./MapToolContext";
import { MapToolLabel } from "./MapToolLabel";

interface LegendControlProps {
  activeFloodLayerName?: string;
  handleLayersToggle?: (evt: MouseEvent | KeyboardEvent) => void;
}

export const LegendControlTool = ({
  activeFloodLayerName,
  handleLayersToggle,
}: LegendControlProps) => {
  const { onMapToolEnter } = useContext(MapToolContext);

  return (
    <LegendControlContainer onMouseEnter={onMapToolEnter}>
      {activeFloodLayerName && (
        <MapToolLabel
          label={activeFloodLayerName}
          permanent
          onClick={handleLayersToggle}
        />
      )}
      <LegendControl
        data-testid="legendControl"
        styleVariant="outlineLight"
        onClick={handleLayersToggle}
        aria-label="Toggle Map Layers panel"
      >
        <Icon iconName="layers" color="contentPrimary" size={16} />
      </LegendControl>
    </LegendControlContainer>
  );
};
